// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animate-element{
    visibility: hidden;
    animation: hero .5s linear forwards;
}
@keyframes hero {
    0%{
        transform: translateY(100px);
        visibility: visible;
    }
    100%{
        transform: translateY(0);
        visibility: visible;
    }
}

.separateLine{
    font-weight: 700;
    text-align: left;
    width: min-intrinsic;
    width: min-content;
    display: table-caption;
    display: -ms-grid;
    -ms-grid-columns: min-content;
}


.Bannerheader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 300;
    width: 100%;
    padding: 0rem 5rem;
    height: 7rem;
    transition: .5s all linear;
    z-index: 11;
}
.Bannerheader>*{
    z-index: 11;
}

.header_left{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7rem;
    width: 10rem;
    margin-left: 1rem;
}
.header_left>img{
    height: 100%;
    display: block;
    padding: 1rem;
    
}
.header_right{
    display: flex;
    gap: 2rem;
}
@media only screen and (max-width: 1200px) {
    .Bannerheader{
        padding: 0rem 1rem 0rem 1rem;
        gap: 1rem;
      }
    .header_right{
        gap: 2rem;
    }
}

@media only screen and (max-width: 1025px) {
    .header_right>*{
        display: none;
    }
  .Bannerheader{
    padding: 0rem 4rem 0rem 1rem;
  }
}

@media only screen and (max-width: 550px) {
    .Bannerheader {
        padding: 0rem 4rem 0rem 1rem;
        gap: 0.5rem;
    }
    .header_left{
        gap: 0.5rem;
    }
.header_left>img{
    width:10rem;
}
.header_left>h6{
    font-size:0.9rem !important;
}
.smallPadding{
    padding:0.62rem 1.71rem;
}
}

@media only screen and (max-width: 360px) {
    .header_left>img{
        width:9rem;
    }    
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IAGpB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;;AAEjB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI;QACI,4BAA4B;QAC5B,SAAS;MACX;IACF;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;EACF;IACE,4BAA4B;EAC9B;AACF;;AAEA;IACI;QACI,4BAA4B;QAC5B,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;IACI,WAAW;AACf;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,uBAAuB;AAC3B;AACA;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".animate-element{\n    visibility: hidden;\n    animation: hero .5s linear forwards;\n}\n@keyframes hero {\n    0%{\n        transform: translateY(100px);\n        visibility: visible;\n    }\n    100%{\n        transform: translateY(0);\n        visibility: visible;\n    }\n}\n\n.separateLine{\n    font-weight: 700;\n    text-align: left;\n    width: min-intrinsic;\n    width: -webkit-min-content;\n    width: -moz-min-content;\n    width: min-content;\n    display: table-caption;\n    display: -ms-grid;\n    -ms-grid-columns: min-content;\n}\n\n\n.Bannerheader{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 300;\n    width: 100%;\n    padding: 0rem 5rem;\n    height: 7rem;\n    transition: .5s all linear;\n    z-index: 11;\n}\n.Bannerheader>*{\n    z-index: 11;\n}\n\n.header_left{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 7rem;\n    width: 10rem;\n    margin-left: 1rem;\n}\n.header_left>img{\n    height: 100%;\n    display: block;\n    padding: 1rem;\n    \n}\n.header_right{\n    display: flex;\n    gap: 2rem;\n}\n@media only screen and (max-width: 1200px) {\n    .Bannerheader{\n        padding: 0rem 1rem 0rem 1rem;\n        gap: 1rem;\n      }\n    .header_right{\n        gap: 2rem;\n    }\n}\n\n@media only screen and (max-width: 1025px) {\n    .header_right>*{\n        display: none;\n    }\n  .Bannerheader{\n    padding: 0rem 4rem 0rem 1rem;\n  }\n}\n\n@media only screen and (max-width: 550px) {\n    .Bannerheader {\n        padding: 0rem 4rem 0rem 1rem;\n        gap: 0.5rem;\n    }\n    .header_left{\n        gap: 0.5rem;\n    }\n.header_left>img{\n    width:10rem;\n}\n.header_left>h6{\n    font-size:0.9rem !important;\n}\n.smallPadding{\n    padding:0.62rem 1.71rem;\n}\n}\n\n@media only screen and (max-width: 360px) {\n    .header_left>img{\n        width:9rem;\n    }    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
